import React from 'react';
import Error from './Error';

export default function UnhandledException({ title = "Something went wrong.", message = "Please try again. If the issue persists, please contact your BDO representative." }) {
    return (<Error title={title} message={message} />);
}